export const colorPrimary = '#8B5CF6';
export const colorPrimaryHover = '#7C3AED';
export const colorPrimaryLight = '#EDE9FE';
export const colorInk = '#332E4A';
export const colorMuted = '#614D4D';
// Non-text only: #A9A9A9 is 2.35:1 on white, so it must not carry text.
export const colorFaint = '#A9A9A9';
export const colorBorder = '#DDD6FE';
export const colorBorderSoft = '#EDE9FE';
export const colorSurface = '#FFFFFF';
export const colorPageBg = '#F7F7FA';
export const colorRowAlt = '#FBFAFE';
export const colorHairline = '#F4F2FA';
export const colorTrack = '#F4F2FA';
// Map stroke colours (kyl_dashboard.jsx MWS layer), not the earlier draft values.
export const colorSelected = '#166534';
export const colorSelectedBorder = '#14532D';
export const colorUnselected = '#4A90E2';
export const colorUnselectedBorder = '#1769A8';
export const colorDataWarm = '#CC6B00';
// Tree cover gain/loss: blue/orange, not green/red — green and red separate by
// ΔE 1.1 under deuteranopia, which is indistinguishable (kyl-sidebar plan §3.5).
export const colorDataCool = '#0052B7';
export const colorWater = '#077BAB';
export const colorBad = '#B91C1C';
// Waterbody surface-water-area bars: latest year vs. prior years.
export const colorAreaLatest = '#077BAB';
export const colorAreaPrior = '#9CC9DC';
// Waterbody season ramp, lightness-ordered (kyl-sidebar plan §8) — nested,
// not stacked: Kharif is the outer/lightest band, Zaid the inner/darkest.
export const colorSeasonKharif = '#A3D3E6';
export const colorSeasonRabi = '#6BAFCB';
export const colorSeasonZaid = '#07628B';
export const colorSeasonTrack = '#EFF3F5';
